export const QC_UI_STRINGS = {
  en: {
    languageGroupAria: "Choose display language",
    quickClarity: "Quick Clarity",
    sessionSummary: "Your session summary",
    sessionLede:
      "Separate what happened from the interpretation you assigned. Confirm the labels that fit before they count toward your patterns.",
    understanding: "What Ahavibes understood",
    emotions: "Emotions that may be present",
    mainEmotion: "Main emotion",
    noMainEmotion: "No main emotion selected.",
    confirmMainEmotion: "Does this main emotion fit?",
    confirmEmotion: "Confirm emotion",
    correctEmotion: "Correct emotion",
    correctedLabel: "Corrected label",
    saveLabel: "Save label",
    mayAlsoBePresent: "May also be present",
    whatHappened: "What happened",
    factsNote: "Observable or directly reported facts only.",
    yourInterpretation: "Your interpretation",
    interpretationNote: "The meaning you appear to have assigned.",
    unknowns: "What remains unknown",
    primaryInsight: "What may be shaping your reaction",
    insightConfirm: "Does this fit your experience?",
    needDetail: "Need one more detail",
    thinkingPattern: "Possible thinking pattern",
    learnMore: "Learn more",
    definition: "Definition",
    example: "Example",
    thoughtCheck: "Thought check",
    questionToConsider: "Question to consider",
    patternConfirm: "Does this pattern fit?",
    actionTitle: "What would you like to do next?",
    actionNote: "Optional. One concrete step is enough. You can skip.",
    suggestedActions: "Suggested next steps from this entry",
    actionPlaceholder: "e.g. Ask one clarifying question before deciding.",
    category: "Category",
    emotion: "Emotion",
    dueDate: "When should this come due?",
    reminderOptIn: "Remind me (email + in-app; no reflection text in the preview)",
    saveAction: "Save action",
    skip: "Skip",
    actionSection: "Action",
    actionSaved: "Action saved.",
    reviewActions: "Review under Actions",
    saving: "Saving…",
    deepLink: "Explore with Structured Reflection (EIER)",
    translating: "Translating…",
    translateHint: "AI translation — check important details in English if needed.",
    translationFailed: "Could not load translation. Try again or switch to English.",
    retryTranslation: "Retry translation",
    insightYes: "Yes",
    insightPartly: "Partly",
    insightNotQuite: "Not quite",
    patternYes: "Yes",
    patternPartly: "Partly",
    patternNotReally: "Not really",
    dueTomorrow: "Tomorrow",
    dueThreeDays: "In three days",
    dueNextWeek: "Next week",
    emotionConfirmed: "Main emotion confirmed",
    emotionCorrected: "Main emotion corrected"
  },
  hi: {
    languageGroupAria: "प्रदर्शन भाषा चुनें",
    quickClarity: "त्वरित स्पष्टता",
    sessionSummary: "आपका सत्र सारांश",
    sessionLede:
      "जो हुआ उसे और जो अर्थ आपने दिया, उन्हें अलग रखें। पैटर्न में गिनने से पहले सही लेबल की पुष्टि करें।",
    understanding: "आहावाइब्स ने क्या समझा",
    emotions: "संभावित भावनाएँ",
    mainEmotion: "मुख्य भावना",
    noMainEmotion: "कोई मुख्य भावना नहीं चुनी गई।",
    confirmMainEmotion: "क्या यह मुख्य भावना सही है?",
    confirmEmotion: "भावना की पुष्टि करें",
    correctEmotion: "भावना सुधारें",
    correctedLabel: "सही लेबल",
    saveLabel: "लेबल सहेजें",
    mayAlsoBePresent: "ये भी हो सकती हैं",
    whatHappened: "क्या हुआ",
    factsNote: "केवल देखी या सीधे बताई गई बातें।",
    yourInterpretation: "आपकी व्याख्या",
    interpretationNote: "जो अर्थ आपने लगाया प्रतीत होता है।",
    unknowns: "अभी अज्ञात",
    primaryInsight: "आपकी प्रतिक्रिया को क्या आकार दे सकता है",
    insightConfirm: "क्या यह आपके अनुभव से मेल खाता है?",
    needDetail: "एक और विवरण चाहिए",
    thinkingPattern: "संभावित सोच पैटर्न",
    learnMore: "और जानें",
    definition: "परिभाषा",
    example: "उदाहरण",
    thoughtCheck: "विचार जाँच",
    questionToConsider: "विचार के लिए प्रश्न",
    patternConfirm: "क्या यह पैटर्न सही है?",
    actionTitle: "आगे क्या करना चाहेंगे?",
    actionNote: "वैकल्पिक। एक ठोस कदम पर्याप्त है। छोड़ सकते हैं।",
    suggestedActions: "इस प्रविष्टि से सुझाए गए अगले कदम",
    actionPlaceholder: "जैसे, निर्णय से पहले एक स्पष्ट प्रश्न पूछें।",
    category: "श्रेणी",
    emotion: "भावना",
    dueDate: "यह कब पूरा करें?",
    reminderOptIn: "मुझे याद दिलाएँ (ईमेल + ऐप; पूर्वावलोकन में चिंतन पाठ नहीं)",
    saveAction: "कार्रवाई सहेजें",
    skip: "छोड़ें",
    actionSection: "कार्रवाई",
    actionSaved: "कार्रवाई सहेजी गई।",
    reviewActions: "कार्रवाइयों में देखें",
    saving: "सहेजा जा रहा है…",
    deepLink: "संरचित चिंतन (EIER) के साथ आगे बढ़ें",
    translating: "अनुवाद हो रहा है…",
    translateHint: "AI अनुवाद — जरूरी विवरण के लिए अंग्रेज़ी देख सकते हैं।",
    translationFailed: "अनुवाद लोड नहीं हुआ। दोबारा कोशिश करें या अंग्रेज़ी चुनें।",
    retryTranslation: "अनुवाद फिर से करें",
    insightYes: "हाँ",
    insightPartly: "कुछ हद तक",
    insightNotQuite: "पूरी तरह नहीं",
    patternYes: "हाँ",
    patternPartly: "कुछ हद तक",
    patternNotReally: "ज़्यादा नहीं",
    dueTomorrow: "कल",
    dueThreeDays: "तीन दिन में",
    dueNextWeek: "अगले सप्ताह",
    emotionConfirmed: "मुख्य भावना की पुष्टि",
    emotionCorrected: "मुख्य भावना सुधारी गई"
  }
};

export const QC_LANG_OPTIONS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" }
];
